module.exports = __webpack_public_path__ + "img/Boy_020019.55faddfb.png";